// @ts-nocheck
/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import {
  Redirect,
  Route,
  Switch,
  useHistory,
  useLocation,
} from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { StyledEngineProvider } from '@mui/material';
import { useSnackbar } from 'notistack';
import { Utils } from './utils/index';
import useCurrentTheme from './theme/useCurrentTheme';
import { initializeAxiosForKeycloak } from './utils/ApiKeycloak';
import { AppRoutes } from './routing/AppRoutes';
import { API_ENDPOINTS } from './const/ApiEndpoints';
// import keycloakConfig from './keycloak-config';
import { setAuth, setPanelNavigation } from 'state/slices/appSlice';
import { useSelector, useDispatch } from 'react-redux';
import useAuth from 'hooks/useAuth';
import { CoreUtils } from 'utils/Utils';
import { PermissionProvider } from 'utils/PermissionContext';

// const initKeycloak = async () => {
//   return keycloakConfig
//     .init({
//       onLoad: 'login-required',
//       KeycloakResponseType: 'code',
//       silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`,
//       checkLoginIframe: false,
//       pkceMethod: 'S256',
//     })
//     .then((auth) => {
//       if (!auth) {
//         window.location.reload();
//       } else {
//         setTimeout(() => {
//           document.dispatchEvent(
//             new CustomEvent('KEYCLOAK_LOGIN_SUCCESS', { detail: { auth } })
//           );
//         }, 1000);
//       }
//       return auth;
//     });
// };

(function handleEmotParams() {
  const params = new URLSearchParams(window.location.search);

  const skipOrg = params.get('skipOrg');
  const realm = params.get('realm');
  const client = params.get('client');
  const returnUrl = params.get('redirectUrl');

  if (skipOrg === 'true' && realm && client) {
    localStorage.setItem('SKIP_ORG', 'true');
    localStorage.setItem('REALM_ID', realm);
    localStorage.setItem('CLIENT_ID', client);
    localStorage.setItem('FROM_EMOT', 'true');
    localStorage.setItem('redirectUrl', returnUrl || '');
    window.history.replaceState({}, '', '/');
  }
})();

if (window.CONFIG.REACT_APP_KEYCLOAK_LOGIN === true) {
  if (!CoreUtils.isValueEmpty(localStorage.getItem('REALM_ID'))) {
    if (CoreUtils.isValueEmpty(localStorage.getItem('token'))) {
      CoreUtils.initKeycloak();
      initializeAxiosForKeycloak();
    } else {
      CoreUtils.initKeycloak();
      initializeAxiosForKeycloak();
    }
  }
} else {
  Utils.ApiUtils.intializeAxios();
}

function App({ notistackRef }) {
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();

  const dispatch = useDispatch();
  const { fetchPanelInfo, panelData } = useAuth();
  const { user } = useSelector((state) => state);
  const [loading, setLoading] = useState(true);
  const [panelInfoData, setPanelInfoData] = useState({});

  const theme = useCurrentTheme();
  const handleKeycloakEvent = React.useCallback(
    async (event) => {
      const { keycloakConfig } = event.detail;
      const keycloakUserData = keycloakConfig.tokenParsed;

      const userData = {
        username: keycloakUserData.preferred_username,
        email: keycloakUserData.email,
        id: keycloakUserData.sub,
      };

      // Dispatch initial authentication state with user set to null
      dispatch(
        setAuth({
          isLoggedIn: keycloakConfig.authenticated,
          token: keycloakConfig.token,
          refresh: keycloakConfig.refreshToken,
          org: keycloakConfig.realm,
          user: null, // Initially null
        })
      );

      try {
        // Fetch panel info first
        const data = await fetchPanelInfo();
        setPanelInfoData(data);

        const panelNavigation = data?.panel_navigation ?? {};

        // Dispatch panel navigation info
        dispatch(
          setPanelNavigation({
            panelNavigation,
          })
        );

        // Update auth state with user data
        dispatch(
          setAuth({
            isLoggedIn: keycloakConfig.authenticated,
            token: keycloakConfig.token,
            refresh: keycloakConfig.refreshToken,
            org: keycloakConfig.realm,
            user: data?.user, // Update user info
          })
        );

        if (
          !localStorage.getItem('REDIRECT_DONE') ||
          window.location?.pathname === '/org'
        ) {
          localStorage.setItem('REDIRECT_DONE', 'true');
          if (!panelNavigation || Object.keys(panelNavigation).length === 0) {
            // If panelNavigation is empty, redirect to welcome
            window.location = '/welcome';
          } else if (panelNavigation?.['admin-dashboard']) {
            // Redirect to Admin Dashboard if available
            window.location = '/admin-dashboard';
          } else if (panelNavigation?.['initial-screening']) {
            // Redirect to Initial Screening if available
            window.location = '/initial-screening/initial-my-queue';
          } else if (panelNavigation?.['ongoing-monitoring']) {
            // Redirect to Ongoing Monitoring if available
            window.location = '/ongoing-screening/ongoing-my-queue';
          } else if (panelNavigation?.['analyst-dashboard']) {
            // Redirect to Ongoing Monitoring if available
            window.location = '/analyst-dashboard';
          } else {
            // If none of the above are present, find the first available route
            const findFirstAvailableRoute = (data) => {
              for (const key in data) {
                if (
                  data[key]?.children &&
                  Object?.keys(data[key]?.children)?.length > 0
                ) {
                  // If children exist, recursively find the first valid child route
                  const childRoute = findFirstAvailableRoute(
                    data[key]?.children
                  );
                  if (childRoute) return childRoute;
                }

                // If no children or valid child route found, return the parent route
                if (data[key]?.route) {
                  return data[key]?.route;
                }
              }
              return null;
            };

            const firstAvailableRoute =
              findFirstAvailableRoute(panelNavigation);

            if (firstAvailableRoute) {
              window.location = firstAvailableRoute;
            } else {
              window.location = '/manager-dashboard'; // Fallback
            }
          }
        }
        setLoading(false);
      } catch (error) {
        console.error('Error fetching panel info:', error);
        setLoading(false);
      }
    },
    [dispatch, setAuth, setLoading, setPanelNavigation, history]
  );

  useEffect(() => {
    document.addEventListener('KEYCLOAK_LOGIN_SUCCESS', handleKeycloakEvent);
    if (window.CONFIG.REACT_APP_KEYCLOAK_LOGIN !== true) {
      setLoading(false);
      return () => {
        document.removeEventListener(
          'KEYCLOAK_LOGIN_SUCCESS',
          handleKeycloakEvent
        );
      };
    }
  }, []);
  useEffect(() => {
    // @ts-ignore
    window.enqueueSnackbar = notistackRef.current.enqueueSnackbar;
  }, []);
  const isLoggedIn = useSelector((state) => state?.app?.auth?.isLoggedIn);

  const userPermissions =
    useSelector((state) => state?.common?.userPermissions) || [];

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <PermissionProvider permissions={userPermissions}>
          <AppRoutes
            loading={loading}
            isLoggedIn={
              window.CONFIG.REACT_APP_KEYCLOAK_LOGIN === true
                ? localStorage.getItem('isLoggedIn')
                : isLoggedIn
            }
          />
        </PermissionProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default App;
